import React, { useContext } from 'react';

import { MajorsApi } from '../apis';
import { api } from '../api';

const MajorsApiContext = React.createContext(new MajorsApi(api));

export const MajorsApiProvider = MajorsApiContext.Provider;
export const useMajorsApi = (): MajorsApi => useContext(MajorsApiContext);
